import { gql } from "@apollo/client";

const GET_USER = gql`
  query skynetUser($id: UUID!) {
    skynetUser(id: $id) {
      id
      firstName
      lastName
      email
      lastLoginAt
      createdAt
      modifiedAt
      effectivePermissions {
        admin {
          read
          write
        }
        aml {
          read
          write
        }
        client {
          read
          write
        }
        file {
          read
          write
        }
        invoice {
          read
          write
        }
        onboarding {
          read
          write
        }
      }
      groups {
        id
        groupId
        groupName
        isGroupAdmin
        group {
          permissions {
            admin {
              defaultRead
              defaultWrite
              maxRead
              maxWrite
            }
            aml {
              defaultRead
              defaultWrite
              maxRead
              maxWrite
            }
            client {
              defaultRead
              defaultWrite
              maxRead
              maxWrite
            }
            file {
              defaultRead
              defaultWrite
              maxRead
              maxWrite
            }
            invoice {
              defaultRead
              defaultWrite
              maxRead
              maxWrite
            }
            onboarding {
              defaultRead
              defaultWrite
              maxRead
              maxWrite
            }
          }
        }
      }
    }
  }
`;

export default GET_USER;
